export const SEND_SMS_MODAL_HEADER = "Send Message";
